<template>
  <div class="leave-topbar">
    <div class="leave-list-topbar">
      <div class="topbar-operation">
        <div class="operation-left">
          <div  class="select-box">请假类型：
            <el-select class="select" v-model="leaveType" placeholder="选择类型" @change="selectType"
              v-show="selectList.length != 0">
              <el-option :label="item.dictLabel" :value="item.dictValue" v-for="(item, index) in selectList"
                value-key="dictValue" :key="index"></el-option>
            </el-select>
          </div>
          <div class="select-box">选择班级：
            <el-cascader class="select" v-model="classNameVal" :placeholder="classPlaceholder"
              :props="classProps" :options="classSelect" @change="changeHandle" clearable></el-cascader>
          </div>
        </div>
        <div class="operation-right">
          <el-date-picker v-model="startTimeShow" type="date" value-format="yyyy-MM-dd" placeholder="起始日期" size="small"
            @change="startChange">
          </el-date-picker>
          &nbsp;
          -
          &nbsp;
          <el-date-picker v-model="endTimeShow" type="date" value-format="yyyy-MM-dd" placeholder="结束日期" size="small"
            @change="endChange">
          </el-date-picker>
          <el-button class="select" size="mini" type="success" @click="selectTime">筛选</el-button>
        </div>
      </div>
    </div>
    <div class="topbar-tabs">
      <div class="tab-item" :class="currentCourseItem == index ? 'current-item' : ''"
        v-for="(item, index) in statusList" :key="index" @click="changeCurrentTabItem(index)">
        {{ item.label }}
      </div>
    </div>
  </div>
</template>

<script>
import search from "@/components/search/search.vue";
export default {
  components: {
    search,
  },
  data() {
    return {
      currentCourseItem: 0,
      startTimeShow: "",
      endTimeShow: "",
      startTime: "",
      endTime: "",
      startTimestamp: 0,
      endTimestamp: 0,
      selectList: [],
      leaveType: "",
      classNameVal: "",
    };
  },
  props: [
    "className",
    "classPlaceholder",
    "classProps",
    "classSelect",
    "courseList",
    "today",
    "statusList",
  ],
  created() {
    this.selectLeaveRecordType();
  },
  mounted() {
    this.classNameVal = this.className;
  },
  methods: {
    // 选择班级
    changeHandle(e) {
      this.$emit("changeHandle", e);
    },
    selectLeaveRecordType() {
      this.post(this.$url.selectLeaveRecordType).then((res) => {
        // console.log(res)
        this.selectList = res.data;
        this.selectList.unshift({
          dictLabel: "全部",
          dictValue: "",
        });
      });
    },
    changeCurrentTabItem(tabsIndex) {
      this.currentCourseItem = tabsIndex;
      this.$emit("input", this.currentCourseItem);
    },
    startChange(e) {
      this.startTime = e;
      this.startTimestamp = new Date(this.startTime).getTime();
    },
    endChange(e) {
      this.endTime = e;
      this.endTimestamp = new Date(this.endTime).getTime();
    },
    selectTime() {
      if (this.startTime && this.endTime) {
        if (this.startTimestamp > this.endTimestamp) {
          return this.$message.warning("起始时间不能小于结束时间");
        }
      }
      this.$emit("selectTime", {
        startTime: this.startTime,
        endTime: this.endTime,
      });
    },
    selectType() {
      this.$emit("selectType", this.leaveType);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./leave-topbar.scss";
</style>
